'use strict';

angular.module('amexReconciliationApp')
  .component('cardAccountsList', {
    templateUrl: 'scripts/views/components/card-accounts-list.html',
    controller: function (TransactionSearchModel,
      AccountListService,
      BillingCycleModel,
      CardBillingCyclesRepository,
      PaginationModelFactory,
      CardSortModel,
      CardFilterModel,
      $scope,
      UserModel,
      roles,
      newBta,
      commercialRecon,
      booleanConstants,
      $state) {
      var self = this;
      var PAGE_SIZE = 20;
      var cardPaginationModel = PaginationModelFactory.create(PAGE_SIZE);

      self.loading = true;

      self.isSuperAdmin = UserModel.isSuperAdmin;

      self.roles = UserModel.roles();
      self.currentRole = TransactionSearchModel.role();

      self.onRoleChanged = function () {
        AccountListService.roleChange(self.currentRole);
      };

      CardSortModel.onCardsChanged($scope, function (cards) {
        cardPaginationModel.repaginate(cards);
      });

      self.pageStart = cardPaginationModel.pageStart;
      self.pageEnd = cardPaginationModel.pageEnd;
      self.pageSize = cardPaginationModel.pageSize;
      self.currentPage = cardPaginationModel.pageNumber;
      self.totalCount = cardPaginationModel.totalCount;
      self.showPagination = cardPaginationModel.showPagination;
      self.updateCurrentPage = cardPaginationModel.updateCurrentPage;
      self.cardFilter = CardFilterModel.filter;
      self.cards = [];
      self.isCardManager = false;
      self.hasCardsAssigned = false;
      self.booleanConstants = booleanConstants;

      var openedRow = null;

      self.$onInit = function () {
        if (TransactionSearchModel.isCardManager()) {
          self.isCardManager = true;
          CardBillingCyclesRepository.getCardManagerSummary()
            .then(function (cardMemberSummary) {
              self.hasCardsAssigned = cardMemberSummary.hasCardsAssigned;
              CardFilterModel.unfilteredCards(cardMemberSummary.cardView);
            })
            .finally(function () {
              self.loading = false;
              toggleFirstRow();
            });
        } else if (TransactionSearchModel.isCardMember()) {
          CardBillingCyclesRepository.getCardmemberSummary()
            .then(function (cardMemberSummary) {
              self.hasCardsAssigned = cardMemberSummary.hasCardsAssigned;
              CardFilterModel.unfilteredCards(cardMemberSummary.cardView);
            })
            .finally(function () {
              self.loading = false;
              toggleFirstRow();
            });
        }
      };

      cardPaginationModel.onRecordsOnCurrentPageChanged($scope, function () {
        self.cards = cardPaginationModel.recordsOnCurrentPage();
      });

      self.toggleRow = function (index, cardId, siteNumber) {
        if (self.cards[index].billingCycles.length === 0) { return; }

        openedRow = openedRow === index ? null : index;
      };

      self.isRowOpen = function (index) {
        return openedRow === index;
      };

      self.rowspanForRow = function (index) {
        if (self.isRowOpen(index)) {
          return self.cards[index].billingCycles.length + 1;
        } else {
          return 2;
        }
      };

      self.enableAccountTooltip = function (index) {
        return self.hasBillingCycles(index) && !self.isRowOpen(index);
      };

      self.billingCyclesForRow = function (index, cardId, siteNumber) {
        var billingCycles;
        if (self.isRowOpen(index)) {
          billingCycles = _.find(self.cards, { 'cardId': cardId, 'siteNumber': siteNumber }).billingCycles;
        } else {
          billingCycles = [_.find(self.cards, { 'cardId': cardId, 'siteNumber': siteNumber }).billingCycles[0]];
        }
        return billingCycles;
      };

      self.showLockIcon = AccountListService.showLockIcon;

      self.getLockColor = AccountListService.getLockColor;

      self.getLockStatusToolTip = AccountListService.getLockStatusToolTip;

      self.hasBillingCycles = function (index) {
        return self.cards[index].billingCycles.length > 0;
      };

      self.billingCycleStatus = function (cardIndex, billingCycleIndex) {
        var billingCycle = self.cards[cardIndex].billingCycles[billingCycleIndex];
        if (!billingCycle) { return ''; }

        if (billingCycle.cycleOpen) {
          return 'cardAccounts.BillingCycleOpen';
        } else {
          return 'cardAccounts.BillingCycleClosed';
        }
      };

      self.getBTAIntlCommercialLink = function (host) {
        let userPreferences = UserModel.currentUserPreferences();
        let currentLocale = 'en-us';
        if (userPreferences.language !== null) {
          currentLocale = userPreferences.language.replace('_', '-').toLowerCase();
        }
        let root = commercialRecon.PRODUCTION + currentLocale + newBta.url;
        if (host.indexOf('-dev')>-1) {
          root = commercialRecon.DEV + currentLocale + newBta.url;
        }
        if (host.indexOf('-qa')>-1) {
          root = commercialRecon.QA + currentLocale + newBta.url;
        }
        return root;
      };

      self.setCookie = function (name, value, exp_days) {
        let d = new Date();
        d.setTime(d.getTime() + (exp_days * 24 * 60 * 60 * 1000));
        const expires = 'expires=' + d.toUTCString();
        document.cookie = name + '=' + value + ';' + expires + ';path=/;domain=.americanexpress.com;secure';
      };

      self.setBTAIntlRedirect = function (card, selectedBillingCycle) {
        const host = window.location.hostname;
        const domain = self.getBTAIntlCommercialLink(host);
        const endDate = selectedBillingCycle.endDate;
        const startDate = selectedBillingCycle.startDate;
        const userObj = UserModel.currentUser();
        let obj = {
          'companyId': userObj.companyId,
          'emulatedUser': userObj.firstName + ' ' + userObj.lastName,
          'emulatedUserId': userObj.username,
          'accountId': card.cardId,
          'endDate': endDate,
          'startDate': startDate,
          'siteNumber': card.siteNumber
        };
        self.setCookie(newBta.URL_PARAMS, JSON.stringify(obj), newBta.COOKIE_EXPIRY_DAY);
        window.location.href = domain;
      };

      self.setupTransactionModel = function (card, selectedBillingCycle){
          if (!selectedBillingCycle) { return; }
          TransactionSearchModel.card({
            siteNumber: card.siteNumber,
            siteName: card.siteName,
            rca: card.rcaNumber,
            bca: card.bcaNumber,
            decryptedCardNumber: card.cardNumber,
            cardMemberName: card.cardMemberName,
            cardId: card.cardId
          });
          BillingCycleModel.billingCycles(card.billingCycles);
          TransactionSearchModel.billingCycle(selectedBillingCycle);
          const role = TransactionSearchModel.isCardManager() ? { currentRole: 'cardManager' } : { currentRole: 'cardmember' };
          $state.go('transactions', role);
      };

      self.goToTransactionListForCard = function (cardId, siteNumber, billingCycleIndex) {
        const card = _.find(self.cards, { 'cardId': cardId, 'siteNumber': siteNumber });
        const selectedBillingCycle = card.billingCycles[billingCycleIndex];
        const cardType = card.cardType;
        if(cardType === newBta.NON_BTA_INTL) {
          self.setupTransactionModel(card, selectedBillingCycle);
        } else {
           self.setBTAIntlRedirect(card, selectedBillingCycle);
        }
      };

      self.enableBillingCycleTransactionTooltip = function (index) {
        return self.hasBillingCycles(index) && !self.isRowOpen(index);
      };

      self.hasSummary = function () {
        return !_.isEmpty(self.cards);
      };

      self.getCurrencyFormat = UserModel.getCurrencyFormat;

      function toggleFirstRow() {
        if (self.cards.length === 1) {
          self.toggleRow(0, self.cards[0].cardId, self.cards[0].siteNumber);
        }
      }

      function gotToTransactionList(allBillingCycles, selectedBillingCycle) {
        BillingCycleModel.billingCycles(allBillingCycles);
        TransactionSearchModel.billingCycle(selectedBillingCycle);
        var role = TransactionSearchModel.isCardManager() ? { currentRole: 'cardManager' } : { currentRole: 'cardmember' };
        $state.go('transactions', role);
      }
    }
  });


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/cardAccountsList.js
// module id = 440
// module chunks = 0